<div class="sections">
  <app-cover></app-cover>
  <app-our-services></app-our-services>
  <app-technologies></app-technologies>
<!--  <app-reviews></app-reviews>-->
  <app-imrpove></app-imrpove>
  <app-our-customers></app-our-customers>
<!--  <app-projects></app-projects>-->
  <app-contact-us></app-contact-us>
</div>
